module.exports = __webpack_public_path__ + "media/images/emblems/Vacallo-coat_of_arms-17ace188a3aa852c6949fc84706aec29.svg";